import {
  Component,
  computed,
  inject,
  input,
  model,
  signal,
  ChangeDetectionStrategy
} from "@angular/core";
import { MatSlideToggleChange } from "@angular/material/slide-toggle";
import { FormTemplate, RawPermissions, ViewPermission } from "../forms.model";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "app-form-assign-perm-dialog",
  templateUrl: "./form-assign-perm-dialog.component.html",
  styleUrl: "./form-assign-perm-dialog.component.scss",
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class FormAssignPermDialogComponent {
  readonly dialogRef = inject(MatDialogRef<FormAssignPermDialogComponent>);
  readonly data = inject<any>(MAT_DIALOG_DATA); //TODO
  readonly form = model(this.data?.form);

  protected readonly nameResolver = this.data.nameResolver;

  showOnlyActive = signal<boolean>(false);
  formTemplate = signal<FormTemplate | null>(null);
  isLoading = signal<boolean>(false);
  rawPermissions = signal<RawPermissions | null>(null);

  parsedEdit = computed(() => this.parseAction(this.rawPermissions()?.edit));
  parsedSave = computed(() => this.parseAction(this.rawPermissions()?.save));

  private parseAction(actionData: any) {
    if (!actionData) return { included: [], excluded: [] };

    return {
      included: (actionData.included || []).flat().map(this.mapToView),
      excluded: (actionData.excluded || []).map(this.mapToView),
    };
  }

  private mapToView = (rawString: string): ViewPermission => {
    const [type, uuid] = rawString.split("$");
    const resolver = this.nameResolver;

    const displayName =
      resolver && uuid
        ? resolver(type, uuid)
        : uuid
          ? uuid.substring(0, 8) + "..."
          : "No data";

    return {
      type: type ? type.toUpperCase() : "UNKNOWN",
      uuid: uuid,
      name: displayName,
      raw: rawString,
    };
  };

  onShowOnlyActiveChange($event: MatSlideToggleChange) {
    this.showOnlyActive.set($event.checked);
  }

  onFormSelected(formTemplate: FormTemplate) {
    this.formTemplate.set(formTemplate);
    this.rawPermissions.set(formTemplate?.permissions as any);
  }

  formIsLoading(isLoading: boolean) {
    this.isLoading.set(isLoading);
  }

  onCloseClick(): void {
    this.dialogRef.close(false);
  }

  onSave() {
    if (this.formTemplate().permissions) {
      this.dialogRef.close(this.formTemplate().permissions);
    }
  }
}
